/**
 * Compare if two variables are both arrays and equal
 *
 * @param a First comparator
 * @param b Second comparator
 * @returns {false|*}
 */

export default function arrayEquals( a, b ) {
	return (
		Array.isArray( a ) &&
		Array.isArray( b ) &&
		a.length === b.length &&
		a.every( ( val, index ) => val === b[ index ] )
	);
}
